<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="searchMenu"></template>
        <template slot="search"></template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadExcelArDetail"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="success"
            v-if="scope.row.status == 'NON_PAY'"
            size="small"
            plain
            @click="immediatePayment(scope.row) "
          >付款</el-button>
        </template>
      </avue-crud>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { paymentDetailOption } from "@/const/salesCloud/paymentDetailOption";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findArDetail } from "@/api/salesCloud/ar";
import { findPaytmentDetail, immediatePay } from "@/api/salesCloud/payment";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { getCompany } from "@/util/auth";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { log } from "util";
import { excelaxios } from "@/util/excelaxios";
export default {
  name: "detail",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: paymentDetailOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      QRCodeDialog: false,
      detailId: this.$route.params.id,
      eleDialog: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      from: {
        text: "text"
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {}
    };
  },
  created() {
    console.log(this);
    this.handleList();
  },
  watch: {},
  mounted() {
    // this.refreshChange(this.page);
  },
  computed: {},
  props: [],
  methods: {
    payMoney(row) {
      console.log(row.id);
      immediatePay(row.id).then(res => {
        console.log(res);
      });
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },

    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.id = this.$route.params.id;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.id = this.$route.params.id;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      // params.arNumber = this.$route.params.arNumber ? this.$route.params.arNumber : ''
      params.id = this.$route.params.id;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      // console.log(this.$refs.crud.resetForm)
      if (this.serviceCategoryId) {
        params.serviceCategoryId = this.serviceCategoryId;
      }
      if (this.serviceItemId) {
        params.serviceItemId = this.serviceItemId;
      }
      this.downloadData = params;
      console.log(params);
      console.log(this);
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      // let params = {}
      console.log(page);
      params.id = this.$route.params.id;
      params.page = page.page.currentPage;
      params.size = page.page.pageSize;
      console.log(params);
      this.downloadData = params;
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },

    handleDetail() {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit() {},
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = this.$route.params;
      params.id = this.$route.params.id;
      console.log(params);
      console.log(this.$route.params);
      this.downloadData = params;
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(params);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave() {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate() {},
    immediatePayment(row) {
      console.log(row);
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then(response => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          let count = 0;
          wxNativePayQuery(data.outTradeNo).then(res => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function() {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success"
                  });
                  _this.handleList();
                }, 1000);
              } else {
                count++;
                if (count < 5) {
                  wxNativePayQuery(data.outTradeNo);
                } else {
                  this.QRCodeDialog = false;
                  this.$message({
                    showClose: true,
                    message: "支付超时",
                    type: "error"
                  });
                  console.log("超时", new Date());
                }
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error"
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
          //???下面的感觉没用
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },

    downloadExcelArDetail() {
      // let params = this.downloadData;
      // let url = `/joins-invoice-system/v1/ar/exportArDetail?`;
      // excelaxios(url, params);
      let params = this.downloadData;
      delete params.page;
      params.size = this.page.total;
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        const list = data.rows;
        for (let i of list) {
          i.status = parseStatus(DIC.STOCK_PAYMENT_STATUS, i.status);
          i.exitTime = formatterDateToUTC(i.exitTime * 1);
          i.payTime = formatterDateToUTC(i.payTime * 1);
          i.residueDegree = i.residueDegree == null ? "" : i.residueDegree;
          i.totalMoney = i.totalMoney == null ? "" : i.totalMoney;
        }
        const header = [];
        for (let i of this.tableOption.column) {
          const obj = {};
          if (i.prop == "payTimeInterval" || i.prop == "startDate_endDate") {
            ("");
          } else {
            obj.k = i.prop;
            obj.v = i.label;
            header.push(obj);
          }
        }
        const fileName = "应付款详情.xlsx";
        exportExcel(header, list, fileName);
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.id = this.$route.params.id;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      }
      findPaytmentDetail(params).then(res => {
        let data = JSON.parse(res.data);
        // this.tableData = data.rows;
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map(item => {
          this.tableLoading = true;
          item.payTime = item.payTime ? formatterDateToUTC(item.payTime) : "";
          item.exitTime = formatterDateToUTC(item.exitTime);
          if (item.status == "NON_PAY") {
            item.status = "未付款";
          } else if (item.status == "SPEND") {
            item.status = "已付款";
          } else {
            item.status = "error:" + item.status;
          }
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "dueNumber", displayName: "应付款编号" },
            { field: "exitNumber", displayName: "退货订单编号" },
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "exitTime", displayName: "退货时间" },
            { field: "status", displayName: "应付款状态" },
            { field: "payTime", displayName: "支付时间" },
            { field: "totalMoney", displayName: "应付款总计金额" }
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json"
        });
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
